import NavigationTabs, { NavigationTab } from "components/NavigationTabs";
import Tag from "components/Tag";
import useLabels from "hooks/useLabels";
import FullTextAnalysisComingSoonTooltip from "./FullTextAnalysisComingSoonTooltip";

export type DetailContentTab =
  | "overview"
  | "full-text-analysis"
  | "references"
  | "citations";

interface DetailContentNavigationProps {
  selectedTab: DetailContentTab;
  onTabClick: (tab: DetailContentTab) => void;
  showFullTextAnalysis?: boolean;
  loadingCitations?: boolean;
  loadingReferences?: boolean;
  hideCitations?: boolean;
  hideReferences?: boolean;
}

export function DetailContentNavigation({
  selectedTab,
  onTabClick,
  showFullTextAnalysis,
  loadingCitations,
  loadingReferences,
  hideCitations,
  hideReferences,
}: DetailContentNavigationProps) {
  const [labels] = useLabels("screens.details.tabs");
  const tabs: NavigationTab[] = [
    {
      id: "overview",
      label: labels["overview"],
      hidden: false,
      disabled: false,
    },
    {
      id: "full-text-analysis",
      label: labels["full-text-analysis"],
      icon: "icon-lock",
      rightElement: (
        <Tag label={labels["coming-soon"]} size="sm" className="decor" />
      ),
      hidden: !showFullTextAnalysis,
      disabled: true,
      tooltip: <FullTextAnalysisComingSoonTooltip />,
    },
    {
      id: "references",
      label: labels["references"],
      hidden: hideReferences,
      disabled: hideReferences,
    },
    {
      id: "citations",
      label: labels["citations"],
      hidden: hideCitations,
      disabled: hideCitations,
    },
  ];

  const handleTabClick = (tabId: string) => {
    onTabClick(tabId as DetailContentTab);
  };

  return (
    <NavigationTabs
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={handleTabClick}
    />
  );
}
